











































import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component({
  components: {}
})
export default class CollectionMagazineNameVolumePossessionInfoTable extends ComponentVue {
  radioValue: string = ''

  headers = [
    {
      text: '',
      align: 'left',
      sortable: false,
      value: 'col1',
      width: '26px'
    },
    {
      text: '所蔵館',
      align: 'left',
      sortable: false,
      value: 'col2'
    },
    {
      text: '巻号所蔵',
      align: 'left',
      sortable: false,
      value: 'col3'
    },
    {
      text: '処理状態',
      align: 'left',
      sortable: false,
      value: 'col4'
    }
  ]

  items = [
    {
      col2: '10 記念',
      col3: '',
      col4: ''
    }
  ]

  created(): void {
    let pushNumber: number = 0
    const maxNumber: number = 10
    if (this.items.length < maxNumber) {
      pushNumber = maxNumber - this.items.length
    }

    for (let i = 0; i < pushNumber; i++) {
      this.items.push({
        col2: '',
        col3: '',
        col4: ''
      })
    }
  }
}
